import { NbrFilterProps } from '../types';
import {
  ChangeableSectionStyles,
  PillsSectionStyles,
  TopSectionStyles,
} from './nbr-filter-section.style';
import {
  NeedsBasedRecOption,
  needsBasedRecAtom,
} from './needs-based-rec-selection.atom';
import { ContentTabsSection } from './sections/content-tabs/content-tabs';
import { NeedsBasedRecLeftContent } from './sections/left-content/left-content';
import { useAtom } from 'jotai';
import { useCallback } from 'react';

const {
  NBRContainerSection,
  TopSection,
  TopContainer,
  TopTitle,
  TopSubtitle,
  TopInquiry,
} = TopSectionStyles;
const { PillsSection, PillsContainer, Pill } = PillsSectionStyles;
const { ChangeableSection, ChangeableContainer, ChangeableSectionLeft } =
  ChangeableSectionStyles;

const NbrFilterSection = ({
  pillData,
  titleSectionData,
  leftContentData,
  contentTabData,
  isEmbedded = false,
}: NbrFilterProps) => {
  const [needsBasedData, setNeedsBasedData] = useAtom(needsBasedRecAtom);

  const isSelected = useCallback(
    (option: NeedsBasedRecOption) => {
      return needsBasedData.selectedOption === option;
    },
    [needsBasedData.selectedOption],
  );
  return (
    <NBRContainerSection className="nbr-embedded-section">
      <TopSection data-testid="TopSection">
        <TopContainer>
          <TopTitle as="h2">{titleSectionData.title}</TopTitle>
          <TopSubtitle>{titleSectionData.subtitle}</TopSubtitle>
          <TopInquiry>{titleSectionData.inquiry}</TopInquiry>
        </TopContainer>
      </TopSection>
      <PillsSection data-testid="PillsSection">
        <PillsContainer>
          {Object.entries(NeedsBasedRecOption).map(([key, value]) => {
            //TODO: use this for the 50/50 experiment removing some tabs
            // if (
            //   isEmbedded &&
            //   [
            //     NeedsBasedRecOption.GENEROSITY_AND_GIVING,
            //     NeedsBasedRecOption.GETTING_INSURED,
            //   ].includes(key as NeedsBasedRecOption)
            // ) {
            //   return null;
            // }

            return (
              <Pill
                key={key}
                aria-label={pillData?.[key as NeedsBasedRecOption]}
                onClick={() =>
                  setNeedsBasedData({
                    selectedOption: value as NeedsBasedRecOption,
                  })
                }
                selected={isSelected(value as NeedsBasedRecOption)}
                label={pillData?.[key as NeedsBasedRecOption]}
              />
            );
          })}
        </PillsContainer>
      </PillsSection>
      <ChangeableSection data-testid="ChangeableSection">
        <ChangeableContainer>
          <ChangeableSectionLeft>
            <NeedsBasedRecLeftContent {...{ leftContentData }} />
          </ChangeableSectionLeft>
        </ChangeableContainer>
        <ContentTabsSection
          contentTabData={contentTabData}
          isEmbedded={isEmbedded}
        />
      </ChangeableSection>
    </NBRContainerSection>
  );
};
export default NbrFilterSection;
